// extracted by mini-css-extract-plugin
export var chevron = "_k2-4";
export var chevronExpanded = "_k2-5";
export var row = "_k2-0";
export var rowBody = "_k2-6";
export var rowDescription = "_k2-7";
export var rowHeader = "_k2-1";
export var rowTitle = "_k2-2";
export var rowTitleComplete = "_k2-3";